var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page gc" },
    [
      _c("SideMenu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content g9" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.project.title))]),
          _vm._v(" "),
          _c(
            "Accord",
            {
              attrs: {
                title: (_vm.isActives ? "Active" : "Archived") + " programs",
              },
            },
            [
              _c(
                "div",
                { staticClass: "grid-33w" },
                [
                  _vm._l(
                    _vm.project.programs.filter(function (x) {
                      return x.isArchived == !_vm.isActives
                    }),
                    function (program) {
                      return _c("ProjectTile", {
                        key: program.programId,
                        attrs: { info: program },
                      })
                    }
                  ),
                  _vm._v(" "),
                  _vm.isActives && !_vm.project.isArchived
                    ? _c(
                        "div",
                        {
                          staticClass: "tile tile-project tile-project-create",
                        },
                        [
                          _c("p", { on: { click: _vm.onNewProgramClick } }, [
                            _vm._v(
                              "\n                        Create program\n                    "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "modalNewProgram", attrs: { title: "Create program" } },
        [
          _c("form", { on: { submit: _vm.onNewProgramSubmit } }, [
            _c("div", { staticClass: "input", attrs: { type: "text" } }, [
              _c("label", [
                _c("span", [_vm._v("Name")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newProgramName,
                      expression: "newProgramName",
                    },
                  ],
                  ref: "programNameInput",
                  attrs: { type: "text", placeholder: "New program name" },
                  domProps: { value: _vm.newProgramName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newProgramName = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "right edit", class: { loading: _vm.isLoading } },
              [_vm._v("Create program")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }